module.exports = __webpack_public_path__ + "assets/945308945090710117c049e984b46105.png";